<template>
  <div class="tab-bar-box">
    <div class="tab-bar-container">
      <router-link
        v-for="i in tabOptions"
        :key="i.label"
        #default="{ href, route, isExactActive,isActive }"
        :to="i.route"
        custom
      >
        <a :href="href" class="tab-bar-item">
          <svg-icon v-if="isActive" :icon-class="i.activeIcon" />
          <svg-icon v-else :icon-class="i.icon" />
          <div :class="{ active:isActive }" class="label">
            {{ i.label }}
          </div>
        </a>
      </router-link>
    </div>
  </div>
</template>

<script>
import { checkPermission } from '@/utils/permission'

export default {
  name: 'HomeTabBar',
  data() {
    return {
      mainTabOptions: [
        {
          label: '农事',
          icon: 'home',
          activeIcon: 'home_active',
          route: {
            name: 'Agricultural'
          },
          permission: ['种植业', '水产业', '养殖业']
        },
        {
          label: '地块',
          icon: 'land',
          activeIcon: 'land_active',
          route: {
            name: 'MyPlot'
          },
          permission: ['种植业', '水产业', '养殖业']
        },
        {
          label: '更多',
          icon: 'means',
          activeIcon: 'means_active',
          route: {
            name: 'MoreList'
          },
          permission: ['种植业', '水产业', '养殖业', '加工业']
        }
      ],
      productTabOptions: [
        {
          label: '加工',
          icon: 'land',
          activeIcon: 'land_active',
          route: {
            name: 'ProcessList'
          }
        },
        {
          label: '半成品',
          icon: 'product',
          activeIcon: 'product_active',
          route: {
            name: 'PartiallyPreparedProducts'
          }
        },
        {
          label: '包装',
          icon: 'home',
          activeIcon: 'home_active',
          route: {
            name: 'PackingList'
          }
        },
        {
          label: '物流',
          icon: 'internet',
          activeIcon: 'internet_active',
          route: {
            name: 'LogisticsList'
          }
        }
      ]
    }
  },
  computed: {
    tabOptions() {
      return ['ProcessList', 'PartiallyPreparedProducts', 'LogisticsList', 'PackingList'].indexOf(this.$route.name) < 0 ? this.mainTabOptionsFilter : this.productTabOptions
    },
    mainTabOptionsFilter() {
      return this.mainTabOptions.filter(i => {
        return checkPermission(i.permission)
      })
    }
  }
}
</script>

<style lang="less" scoped>
@tab-bar-height: 60px;
.tab-bar-box {
  width: 100%;
  height: @tab-bar-height;
}
.tab-bar-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: table;
  height: @tab-bar-height;
  width: 100%;
  background: #fff;
  box-shadow: 0 1px 28px 2px rgba(202, 202, 202, 0.4);
}
.tab-bar-item {
  display: table-cell;
  width: 25%;
  height: 100%;
  text-align: center;
  vertical-align: middle;
  &:active {
    background-color: #f2f3f5;
  }
  .svg-icon {
    width: 20px;
    height: 20px;
  }
  .label {
    font-size: 12px;
    color: #b5b5b5;
    &.active {
      color: @primary-color;
    }
  }
}
</style>
